import React from 'react'

function Logo() {
    return (
        <div className="logo">
            <img src="/img/pills64.png" alt="Logo" />
            <span className="text" >pills</span>
        </div>
    )
}


export default Logo;